import * as bootstrap from "bootstrap";
import Common from "./utils/Common";
import Homepage from "./pages/Homepage";
import ProductDetailsPage from "./pages/ProductDetailsPage";
import DesignerDetailsPage from "./pages/DesignerDetailsPage";
import ViewFittingPage from "./pages/ViewFittingPage";
import OTPPage from "./pages/OTPPage";
import LoginPage from "./pages/LoginPage";
import OnsiteLandingPage from "./pages/OnsiteLandingPage";
import OnsiteLandingPage2024Q4 from "./pages/OnsiteLandingPage2024Q4";
import OnsiteThankyouPage2024Q4 from "./pages/OnsiteThankyouPage2024Q4";
import EventDetailsPage from "./pages/EventDetailsPage";
import MetalookPage from "./pages/MetalookPage";
import DigitalFashionPage from "./pages/DigitalFashionPage";
import ProductListingPage from "./pages/ProductListingPage";
import BlogDetailsPage from "./pages/BlogDetailsPage";

window.addEventListener("load", () => {
  const pageHomeDOM = document.querySelector(".page-wrapper#page-home");
  if (pageHomeDOM) {
    let pageHome = new Homepage(pageHomeDOM);
    pageHome.init();
  }

  const pageDesignerDetailsDOM = document.querySelector(
    ".page-wrapper#page-designer-details"
  );
  if (pageDesignerDetailsDOM) {
    let pageDesignerDetails = new DesignerDetailsPage(pageDesignerDetailsDOM);
    pageDesignerDetails.init();
  }

  const pageProductListingDOM = document.querySelector(
    ".page-wrapper#page-product-listing"
  );
  if (pageProductListingDOM) {
    let pageProductListing = new ProductListingPage(pageProductListingDOM);
    pageProductListing.init();
  }

  const pageProductDetailsDOM = document.querySelector(
    ".page-wrapper#page-product-details"
  );
  if (pageProductDetailsDOM) {
    let pageProductDetails = new ProductDetailsPage(pageProductDetailsDOM);
    pageProductDetails.init();
  }

  const pageEventDetailsDOM = document.querySelector(
    ".page-wrapper#page-events-details"
  );
  if (pageEventDetailsDOM) {
    let pageEventDetails = new EventDetailsPage(pageEventDetailsDOM);
    pageEventDetails.init();
  }

  const pageDigitalFashionDOM = document.querySelector(
    ".page-wrapper#page-digital-fashion"
  );
  if (pageDigitalFashionDOM) {
    let pageDigitalFashion = new DigitalFashionPage(pageDigitalFashionDOM);
    pageDigitalFashion.init();
  }

  const pageMetalookDOM = document.querySelector(".page-wrapper#page-metalook");
  if (pageMetalookDOM) {
    let pageMetalook = new MetalookPage(pageMetalookDOM);
    pageMetalook.init();
  }

  const pageBlogDetailsDOM = document.querySelector(
    ".page-wrapper#page-blog-details"
  );
  if (pageBlogDetailsDOM) {
    let pageBlogDetails = new BlogDetailsPage(pageBlogDetailsDOM);
    pageBlogDetails.init();
  }

  const pageViewFittingDOM = document.querySelector(
    ".page-wrapper#page-view-fitting"
  );
  if (pageViewFittingDOM) {
    let pageViewFitting = new ViewFittingPage(pageViewFittingDOM);
    pageViewFitting.init();
  }

  const pageOTPDOM = document.querySelector(".page-wrapper#page-otp");
  if (pageOTPDOM) {
    let pageOTP = new OTPPage(pageOTPDOM);
    pageOTP.init();
  }
  /*
  const pageOnsiteLandingDOM = document.querySelector(
    ".page-wrapper#page-onsite-landing"
  );
  if (pageOnsiteLandingDOM) {
    let pageOnsiteLanding = new OnsiteLandingPage(pageOnsiteLandingDOM);
    pageOnsiteLanding.init();
  }
  */
  const pageOnsiteLanding2024Q4DOM = document.querySelector(
    "section#page-onsite-landing-2024q4"
  );
  if (pageOnsiteLanding2024Q4DOM) {
    let pageOnsiteLanding2024Q4 = new OnsiteLandingPage2024Q4(
      pageOnsiteLanding2024Q4DOM
    );
    pageOnsiteLanding2024Q4.init();
  }
  

  const pageOnsiteThankyou2024Q4DOM = document.querySelector(
    "section#page-onsite-thankyou-2024q4"
  );
  if (pageOnsiteThankyou2024Q4DOM) {

    let pageOnsiteLanding2024Q4 = new OnsiteLandingPage2024Q4(
      pageOnsiteThankyou2024Q4DOM
    );
    pageOnsiteLanding2024Q4.init();
    let pageOnsiteThankyou2024Q4 = new OnsiteThankyouPage2024Q4(
      pageOnsiteThankyou2024Q4DOM
    );
    pageOnsiteThankyou2024Q4.init();
  }

  const loginDOM = document.querySelector("#email-validation");
  if (loginDOM) {
    let login = new LoginPage(loginDOM);
    login.init();
  }

  let common = new Common();
  common.init();
});
